import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Survey = () => {
  // Komponen bantu untuk menghindari duplikasi kode
  const renderSelectQuestion = (id, label, options) => (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <select id={id} name={id} required>
        <option value="">-- Pilih Jawaban --</option>
        {options.map((option) => (
          <option value={option.toLowerCase().replace(/\s+/g, '_')} key={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
  return (
    <>
      <Navbar />
      <div>
        {/* Header */}
        <header className="header-banner" id="beranda">
          <h2>SURVEY</h2>
        </header>

        {/* Survey Title */}
        <h3 className="survey-title">
          Kami menghargai masukan Anda untuk meningkatkan kualitas layanan dan informasi di website Komite SKK Transportasi dan Logistik. Silakan isi survei singkat berikut ini.
        </h3>

        {/* Survey Form */}
        <form action="#" method="post" className="form-survey">
          <div className="form-group">
            <label htmlFor="nama">Nama</label>
            <input type="text" id="nama" name="nama" required />
          </div>

          <div className="form-group">
            <label htmlFor="Asal_Instansi">Asal Instansi</label>
            <input type="text" id="Asal_Instansi" name="Asal_Instansi" required />
          </div>

          {/* Pertanyaan pilihan */}
          {renderSelectQuestion(
            "informasi",
            "Seberapa mudah Anda menemukan informasi yang Anda cari di website Komite SKK Transportasi dan Logistik?",
            [
              "Sangat Mudah",
              "Mudah",
              "Cukup",
              "Sulit",
              "Sangat Sulit"
            ]
          )}

          {renderSelectQuestion(
            "fitur",
            "Apakah fitur-fitur yang tersedia di website Komite SKK Transportasi dan Logistik membantu Anda dalam menyelesaikan kebutuhan Anda?",
            [
              "Sangat Membantu",
              "Membantu",
              "Cukup Membantu",
              "Kurang Membantu",
              "Tidak Membantu"
            ]
          )}

          {renderSelectQuestion(
            "kepuasan_informasi",
            "Seberapa puas Anda dengan layanan informasi/konten yang tersedia di website Komite SKK Transportasi dan Logistik?",
            [
              "Sangat Puas",
              "Puas",
              "Cukup Puas",
              "Kurang Puas",
              "Tidak Puas"
            ]
          )}

          {renderSelectQuestion(
            "layanan_bantuan",
            "Bagaimana kualitas layanan bantuan/kontak di website Komite SKK Transportasi dan Logistik?",
            [
              "Sangat Baik",
              "Baik",
              "Cukup",
              "Buruk",
              "Sangat Buruk"
            ]
          )}

          {renderSelectQuestion(
            "alur_pengajuan",
            "Bagaimana pendapat Anda tentang kejelasan alur pengajuan layanan SKKK, SKKNI, dan SKKI di website Komite SKK Transportasi dan Logistik?",
            [
              "Sangat Jelas dan Mudah Dipahami",
              "Cukup Jelas",
              "Kurang Jelas",
              "Tidak Jelas",
              "Tidak tahu/tidak pernah menggunakan layanan ini"
            ]
          )}

          {renderSelectQuestion(
            "pemahaman_prosedur",
            "Seberapa mudah Anda memahami persyaratan dan prosedur pengajuan SKKK/SKKNI/SKKI di website Komite SKK Transportasi dan Logistik?",
            [
              "Sangat Mudah",
              "Mudah",
              "Cukup",
              "Sulit",
              "Sangat Sulit"
            ]
          )}

          {renderSelectQuestion(
            "proses_verifikasi",
            "Seberapa cepat proses verifikasi atau tanggapan setelah pengajuan dilakukan?",
            [
              "Sangat Cepat",
              "Cepat",
              "Sedang",
              "Lambat",
              "Sangat Lambat"
            ]
          )}

          {renderSelectQuestion(
            "tracking",
            "Apakah fitur pelacakan status pengajuan (Tracking) membantu Anda dalam memantau proses SKKK/SKKNI/SKKI?",
            [
              "Sangat Membantu",
              "Membantu",
              "Cukup Membantu",
              "Kurang Membantu",
              "Tidak Membantu"
            ]
          )}

          {renderSelectQuestion(
            "kepuasan_keseluruhan",
            "Seberapa puas Anda terhadap keseluruhan pelayanan pengajuan SKKK/SKKNI/SKKI melalui website ini?",
            [
              "Sangat Puas",
              "Puas",
              "Cukup Puas",
              "Kurang Puas",
              "Tidak Puas"
            ]
          )}

          {/* Saran */}
          <div className="form-group">
            <label htmlFor="saran">Saran atau komentar</label>
            <textarea id="saran" name="saran" rows="4"></textarea>
          </div>

          {/* Tombol Submit */}
          <div className="form-group">
            <input type="submit" value="Kirim" />
          </div>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default Survey;
